// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dntsKD4S8xgOTL7J44c8 {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 30px;
  border: 2px solid #000000; /* Add the desired border properties */
  border-radius: 100px; /* Add the desired border radius */
  padding: 8px; /* Add padding to create some space between the text and the border */
  overflow: hidden;
  cursor: pointer;
}

.bOnBGiDIztE6zntce0x2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: transparent;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  user-select: none;

}

.cbOEqh43oTj6JWNWP3Oa {
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; */
  width: 100px;
  justify-content: center;
  text-align: center;
}

.e52qTl_DDbBcfcmbUa8G{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* display: flex; */
  justify-content: center; /* Horizontally center the elements */
  align-items: center;
}

.e52qTl_DDbBcfcmbUa8G p{
  display: flex;
  margin-right: 10px !important;
  text-align: center;
  margin: 0;
  justify-content: center;
  align-items: center;
  /* width: 100%; */
}

.cbOEqh43oTj6JWNWP3Oa p {
  text-align: center;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/BlurredTextBox.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,sCAAsC;EACjE,oBAAoB,EAAE,kCAAkC;EACxD,YAAY,EAAE,qEAAqE;EACnF,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;;AAEnB;;AAEA;EACE;;;;cAIY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb","sourcesContent":[".blurredTextbox {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 30px;\n  border: 2px solid #000000; /* Add the desired border properties */\n  border-radius: 100px; /* Add the desired border radius */\n  padding: 8px; /* Add padding to create some space between the text and the border */\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.blurredText {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: transparent;\n  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  user-select: none;\n\n}\n\n.overlayText {\n  /* position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; */\n  width: 100px;\n  justify-content: center;\n  text-align: center;\n}\n\n.textBox{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  /* display: flex; */\n  justify-content: center; /* Horizontally center the elements */\n  align-items: center;\n}\n\n.textBox p{\n  display: flex;\n  margin-right: 10px !important;\n  text-align: center;\n  margin: 0;\n  justify-content: center;\n  align-items: center;\n  /* width: 100%; */\n}\n\n.overlayText p {\n  text-align: center;\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blurredTextbox": `dntsKD4S8xgOTL7J44c8`,
	"blurredText": `bOnBGiDIztE6zntce0x2`,
	"overlayText": `cbOEqh43oTj6JWNWP3Oa`,
	"textBox": `e52qTl_DDbBcfcmbUa8G`
};
export default ___CSS_LOADER_EXPORT___;
